








import { createComponent, ref } from "@vue/composition-api";
import { useActions } from "@/shared/useMegaraxClient";
import { ListActions, Resource } from "@megarax/client/src/actions";

interface Props {
  resource: Resource<ListActions<any>>;
}

export default createComponent<Props>({
  components: {},
  props: {
    resource: { required: true },
  },
  setup(props, ctx) {
    const filterOptions = ref<any[] | null>(null);

    const resourceActions = useActions(props.resource);

    async function fetchFilterOptions() {
      const { items } = await resourceActions.fetchList();

      filterOptions.value = items.map((item) => ({
        text: item.str,
        value: item.id,
      }));
    }
    fetchFilterOptions();

    return { filterOptions };
  },
});
